const chats = [
    {
        name: 'Julius Iyela',
        src: './register.png',
        time: '12:19'
    },
    {
        name: 'Adeyemi Kolade',
        src: './samantha.jpg',
        time: '1:20',
        active: true
    },
    {
        name: 'Abayomi Adisa',
        src: './student.png',
        time: '12:21'
    },
    {
        name: 'Umar Abacha',
        src: './student.png',
        time: '9:20',
        active: true
    },
    {
        name: 'Chinedu Ugorgi',
        src: './login.png',
        time: '03:12'
    },
    {
        name: 'Ugorgi Jonas',
        src: './about.png',
        time: '08:12',
        active: true
    },

    {
        name: 'Julius Iyela',
        src: './register.png',
        time: '12:19'
    },
    {
        name: 'Chinedu Ugorgi',
        src: './login.png',
        time: '03:12'
    },
    {
        name: 'Adeyemi Kolade',
        src: './samantha.jpg',
        time: '1:20'
    },

    {
        name: 'Umar Abacha',
        src: './student.png',
        time: '9:20'
    },

    {
        name: 'Ugorgi Jonas',
        src: './about.png',
        time: '08:12',
        active: true
    },
    {
        name: 'Abayomi Adisa',
        src: './student.png',
        time: '12:21'
    }
];

export default chats;
